module.exports = __webpack_public_path__ + "img/7-2.8e80a8ae.png";